export default __webpack_public_path__ + "static/LogoFloral-b211996b0631b0ccf3e95da80e5eb5c7.png";